import React, { PropsWithChildren } from "react";

export default function RetailerCard({ children }: PropsWithChildren) {
	return (
		<div className="card" style={{ padding: "24px", minHeight: "fit-content" }}>
			{children}
		</div>
	);
}
